import React from "react";
import { Box, Text } from "@chakra-ui/react";

const TextBlockPreview = ({ block }) => {
    return (
        <Box 
            mt={block.props.marginTop + "px"}
            mr={block.props.marginRight + "px"}
            mb={block.props.marginBottom + "px"}
            ml={block.props.marginLeft + "px"}
        >
            <Text 
                fontSize={block.props.fontSize + "px"} 
                color={block.props.color}
                textAlign={block.props.alignment}
                fontWeight={block.props.bold ? "bold" : "normal"}
                fontStyle={block.props.italic ? "italic" : "normal"}
                textDecoration={block.props.underline ? "underline" : "none"}
            >
                {block.props.text}
            </Text>
        </Box>
    );
};

export default TextBlockPreview;